import {
  isTeamSharePointUrl,
  parseSharePointUploadError,
} from './sharepointSiteUrl.js';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8000';

export async function resolveSharePointAccessTokenForUpload(folderUrl, idToken) {
  const trimmed = String(folderUrl || '').trim();
  const isSharePoint = trimmed.includes('sharepoint.com')
    || trimmed.includes('onedrive.live.com')
    || trimmed.includes('1drv.ms');
  if (!isSharePoint || isTeamSharePointUrl(trimmed)) {
    return undefined;
  }
  if (!idToken) {
    throw new Error('Missing sign-in token for OneDrive access.');
  }
  const res = await fetch(`${API_BASE}/api/ms/graph/token`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${idToken}` },
  });
  const text = await res.text();
  if (!res.ok) {
    throw new Error(`Microsoft sign-in required for OneDrive (${res.status}).`);
  }
  const data = JSON.parse(text);
  if (!data?.access_token) {
    throw new Error('Microsoft sign-in returned no access token.');
  }
  return data.access_token;
}

export function folderUploadErrorMessage(err, fallback = 'Failed to start folder upload. Please try again.') {
  const parsed = parseSharePointUploadError(err?.response?.data ?? err);
  if (parsed?.message) return parsed.message;
  return fallback;
}

export function isSharePointSiteNotGrantedError(err) {
  const parsed = parseSharePointUploadError(err?.response?.data ?? err);
  return parsed?.code === 'SHAREPOINT_SITE_NOT_GRANTED';
}

export function uploadPollErrorMessage(pollPayload, fallback = 'Folder upload failed. Please try again.') {
  if (!pollPayload?.uploadFailed) return null;
  const parsed = parseSharePointUploadError({
    code: pollPayload.uploadErrorCode,
    message: pollPayload.uploadError,
  });
  return parsed?.message || pollPayload.uploadError || fallback;
}
